// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content{width:calc(100% - 200px);min-height:100vh;margin-left:auto;padding-top:80px;background:#f2f2f2}@media(max-width:767.98px){.content{padding-top:65px;width:100%}}", ""]);
// Exports
module.exports = exports;
